<template>
  <svg
    height="44"
    viewBox="0 0 44 44"
    width="44"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fill-rule="evenodd"
    >
      <path
        d="m21.8624 43.7207c8.821 0 16.415-5.227 19.871-12.751h-39.743c3.453 7.524 11.05 12.751 19.872 12.751"
        fill="#ffd900"
      />
      <path
        d="m21.8624 0c-8.822 0-16.419 5.229-19.872 12.751h39.743c-3.456-7.522-11.05-12.751-19.871-12.751"
        fill="#000"
      />
      <path
        d="m0 21.8603c0 3.251.717 6.335 1.99 9.109h39.743c1.275-2.774 1.988-5.858 1.988-9.109 0-3.252-.713-6.335-1.988-9.109h-39.743c-1.273 2.774-1.99 5.857-1.99 9.109"
        fill="#ed1c24"
      />
    </g>
  </svg>
</template>
